import React, {useEffect, useState} from 'react';
import Swal from "sweetalert2";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useParams} from "react-router";
import {useQuery} from "@tanstack/react-query";
import referralsService from "../../../../services/web/referrals-service.js";
import AlertMessages from "../../../../components/messages/alert-message.js";
import projectUtils from "../../../../utils/project-utils.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";

const ReferralsForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [state, setState] = useState({name: ""});
    const [isLoading, setIsLoading] = useState(false)
    const onChange = ({target: {value, id}}) => handleInputs(value, id)

    const handleInputs = (value, id) => {
        setState(prev => ({...prev, [id]: value}));
    }

    const { refetch: refetchReferrals, fetchStatus} = useQuery({
        queryFn: () =>  referralsService.get(id).then((data) => {
            setState(prev => ({ ...prev, ...data }));
            return []
        }),
        queryKey: ['referrals'],
        enabled: !!id
    });

    useEffect(() => {
        if (id) {
            if (fetchStatus === 'idle') setIsLoading(false)
            else setIsLoading(true)
        }
    }, [fetchStatus]);

    const save = () =>{
        const formData = new FormData();

        const form = {
            name: state.name
        };

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        if (!!id) formData.append('_method', 'PUT');


        const response = !!id ? referralsService.edit(id, formData) : referralsService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!id);
                if (id) {
                    refetchReferrals();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = AlertMessages[message] ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            });

    }
    const destroy = () => {
        Swal.fire({
            title: "Excluir",
            text: `Excluir o encaminhamento "${state.name}"?`,
            icon: "warning",
            confirmButtonText: "Sim",
            confirmButtonColor: "#063A6C",
            cancelButtonText: "Não",
            cancelButtonColor: "#c10007",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        }).then(({isConfirmed}) => {
            if (isConfirmed) {
                referralsService.destroy(id).then(() => {
                    navigateToList()
                    projectUtils.success(true, "Excluído com sucesso");
                })
            }
        });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            save()
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [state]);

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/referrals/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/referrals`;
        navigate(urlDev, isBlank);
    }

    const newReferral = () => {
        let isBlank = false;
        let urlDev = `/referrals/form`;
        navigate(urlDev, isBlank);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Encaminhamento
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => newReferral()}>
                            <FaPlus/>
                            Adicionar encaminhamento
                        </Button>
                    </>
                }
            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12">
                                <InputForm id="name" value={state.name} label="Nome *" onChange={onChange}/>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    (id) &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>

        </Template>
    );
};

export default ReferralsForm;